
































import { Component, Vue } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';

@Component({
  components: {
    CommonButton,
  },
})
export default class LoginBase extends Vue {
  private theoryLogo: string = require('../../assets/logotest.png');
  private buttonColor = '#4384f3';
  private createOrganization() {
    this.$router.push({ name: 'createOrganization' });
  }
}
